<template>
    <div class="container card p-5 shadow">
        <h2>{{$t('EDIT_PATIENT')}}</h2>
        <hr>
        
        <b-alert
            :show="dismissCountDown"
            dismissible
            fade
            :variant="response.success === true ? 'success' : 'danger'"
            @dismissed="dismissCountDown = 0"
            >
            {{response.message}}
        </b-alert>

        <div id="form">
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('FIRST_NAME')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.firstName" type="text" class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('LAST_NAME')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.lastName" type="text" class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('EMAIL')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.email" type="email" class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('BIRTHDATE')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input type="date" class="form-control" v-model="patient.birthdate">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('SIS')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.sis" type="text" class="form-control">
                </div>
            </div>
            <!--<div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('PHONE')}}</span>
        </div>
        <input v-model="patient.phone" type="text"  class="form-control" placeholder="Enter Phone" >
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('MOBILE_PHONE')}}</span>
        </div>
        <input v-model="patient.mobilePhone" type="text"  class="form-control" placeholder="Enter Mobile Phone" >
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('CITY')}}</span>
        </div>
        <input v-model="patient.city" type="text"  class="form-control" placeholder="Enter City" >
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('ADDRESS')}}</span>
        </div>
        <input v-model="patient.address" type="text"  class="form-control" placeholder="Enter Address" >
    </div>
    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">{{$t('POSTCODE')}}</span>
        </div>
        <input v-model="patient.postcode" type="text"  class="form-control" placeholder="Enter Postcode" >
    </div>-->
            <div class="input-group mb-3">
                <div class="col-12">
                    <span id="inputGroup-sizing-lg">{{$t('HEIGHT')}} <span class="text-red">*</span></span>
                </div>
                <div class="col-5">
                    <input v-model="patient.height" type="text" class="form-control">
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span for="inputGroupSelect01">{{$t('GENDER')}}</span>
                </div>
                <div class="col-5">
                    <select v-model="patient.gender" class="custom-select" id="inputGroupSelect01">
                        <option :value="0"> {{$t('MALE')}} </option>
                        <option :value="1"> {{$t('FEMALE')}} </option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <button @click="editPatient()" type="button" class="mb-3">{{$t('EDIT_PATIENT')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            patient :
            {
                "firstName": "",
                "lastName": "",
                "email": "",
                "sis": "",
                "phone": "",
                "mobilePhone": "",
                "city": "",
                "postcode": "",
                "address": "",
                "countryId": "",
                "height": "",
                "gender": 1,
                "language": {
                    "title": ""
                }
            },
            response: {
                success: null,
                message: ""
            },
            countries: [],
            selectedCountryId: '',
            dismissCountDown: 0
        }
    },
    computed: {
        languages() {
            return this.$store.getters.systemLanguages || [];
        }
    },
    methods: {
        getCountries: function(){
            let self = this;
            this.$http.get("/api/countries/")
                .then(response =>
                {
                    self.countries = response.data;
                    
                })
                .catch();
        },
        editPatient: function(){
            let self = this;
            this.$http.put(`/api/patients/${this.$route.params.id}/edit`, this.patient)
                .then(response =>
                {
                    self.response = response.data;
                })
                .catch();
        },
        loadPatient: function(){
            let self = this;
            this.$http.get("/api/patients/" + this.$route.params.id)
                .then(response =>
                {
                    self.patient = response.data;

                })
                .catch(error =>
                {
                    this.$router.push('/404');
                });
        }
    },
    created: function () {
        this.getCountries();
        this.loadPatient();
    },
    watch: {
        response: function(val){
            this.dismissCountDown = 3;
            if(val.success === true)
            {
                setTimeout(() => {this.$router.push('/patients')}, 1500)
            }
        },
        
    }
}
</script>
<style lang="scss">
    @import "~vue-datetime/dist/vue-datetime.min.css";
div.input-group-prepend{
    span.input-group-text {
        width: 200px;
    }
}

div.vdatetime.theme-doctor{
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}

.theme-doctor
{
    .vdatetime-popup__header,
    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span{
        background: #39566e;
    }
    // .vdatetime-year-picker__item--selected,
    // .vdatetime-month-picker__item--selected
    // .vdatetime-time-picker__item--selected,
    .vdatetime-popup__actions__button{
        color: #39566e;
    }
}

    .rounded-circle {
        height: 1.5rem;
        width: 1.5rem;
    }
</style>
